(function () {
  'use strict';

  angular
    .module('finance.vckkcat')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.financekkcat', {
        url: '/financekkcat',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;kkcatsearch kkcat="" kkcatref="" editinplace="true"&gt;</tt></h3><div ui-view="kkcatsearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;kkcatsearch kkcat="" kkcatref="" parentsave=""&gt;</tt></h3><div ui-view="kkcatsearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;kkcateditor kkcat="" mode="" onClose=""&gt;</tt></h3><div ui-view="kkcateditview"></div>
              <h3 class="alert alert-info"><tt>&lt;kkcatnew&gt;</tt></h3><div ui-view="kkcatnewview"></div>
              <h3 class="alert alert-info"><tt>&lt;kkcatlist kkcats="?"&gt;</tt></h3><div ui-view="kkcatlistview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.financevckkcat entered');
        }
      });
    
    
    $stateProvider
      .state('playground.financekkcat.allcomponents', {
        url: '/allcomponents',
        resolve: {
          kkcat: function () {
            return '';
          },
          kkcatref: function () {
            return '';
          },
          somekkcat: function (Kkcat) {
            return Kkcat.$find('572b31b07c01597e3e150923');
          },
          allkkcats: function (Kkcat) {
            return Kkcat.$search({active: true});
          },
          parentsavesearch: function () {
            return function (kkcat, kkcatref) {
              console.log('debug: dummy parentsave called for kkcatsearch with: ', kkcat, kkcatref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'kkcatsearchview@playground.financekkcat': {
            component: 'kkcatsearch',
            bindings: {
              kkcat: 'kkcat',
              kkcatref: 'kkcatref',
              editinplace: 'eip'
            }
          },
          'kkcatsearchview2@playground.financekkcat': {
            component: 'kkcatsearch',
            bindings: {
              kkcat: 'kkcat',
              kkcatref: 'kkcatref',
              parentsave: 'parentsavesearch'
            }
          },
          'kkcateditview@playground.financekkcat': {
            component: 'kkcateditor',
            bindings: {
              kkcat: 'somekkcat'
            }
          },
          'kkcatnewview@playground.financekkcat': {
            component: 'kkcatnew',
            bindings: {
            }
          },
          'kkcatlistview@playground.financekkcat': {
            component: 'kkcatlist',
            bindings: {
              kkcats: 'allkkcats'
            }
          }
        },
        onEnter: function () {
          console.log('playground.financekkcat.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






